// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"680":"e9dc374c","835":"97aba9b3"}[chunkId] + ".js";
};